import { EventEmitter } from '@angular/core';
import { Hub } from './hub';
import { GeneratedProxy, CommandResult } from './hub-proxies';
import { filter, takeWhile, map, merge, first } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

export interface HubProxy<T> {
    model: T;
}

export class Resource<T extends GeneratedProxy<T, U>, U> {
    constructor(
        public proxy: T,
        public hub: Hub<U>,
        private topic: string,
        mapping?: (value) => any) {
        this.proxy = proxy;

        if(mapping) {
            this.model$ = this.hub.model$.pipe(map(mapping));
        }else{
            this.model$ = this.hub.model$;
        }
    }

    public model$;

    public get commandResult$() {
        return this.hub.commandResult$;
    }

    public commandResult(commandResult: CommandResult): Observable<any> {
        const newObservable = this.commandResult$
            .pipe(
                filter((current: CommandResult) => {
                    if(!current) {
                        return false;
                    }
                    return current.commandId === commandResult.commandId;
                }),
            );

        return of(commandResult).pipe(first()).pipe(merge(newObservable));
    }

    public isSubscribed: boolean = true;

    public reconnect(){
        if(!this.isSubscribed) {
            this.hub.subscribe(this.topic);
        }
        this.isSubscribed = true;
    }

    public destroy() {
        this.hub.unsubscribe(this.topic);
        this.isSubscribed = false;
    }
}
